import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useEffect, useReducer, useMemo, useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Link, Loader, Modal, Icon, Button, Section, SearchBar } from 'hoi-poi-ui';
import { debounce, getPriorityTranslation } from "../../../../lib/helpers";
import { useWeb5Context } from "../../../../lib/Web5Context";
import SectionList from "../../../../components/SectionList";
import NoData from "../../../../components/SvgIcons/NoData";
import { showErrorToast } from "../../../../lib/errors";
import { getValueDetails, getValues, searchValues, getValuesUsage } from "../../../../lib/services/valueLists";
import FormValueListValue from "../../FormValueListValue";
import styles from "./styles/styles";
import processFromServer from "../../../../components/ForceForm/lib/processFromServer";
const useStyles = createUseStyles(styles, 'ValueListValues');
const PAGE_NUMBER = 30;
const initialState = {
  id: null,
  values: null,
  isLoading: false,
  isInitLoading: true,
  hasAllValues: false,
  error: false,
  hasDragAndDrop: false
};
function reducer(state, action) {
  var _state$values;
  let newValues = [];
  switch (action.type) {
    case 'init':
      return _objectSpread(_objectSpread({}, initialState), {}, {
        id: action.id,
        values: []
      });
    case 'addValues':
      newValues = [...(state.values || []), ...action.values];
      return _objectSpread(_objectSpread({}, state), {}, {
        isInitLoading: false,
        values: newValues,
        hasAllValues: state.id ? action.values.length < PAGE_NUMBER : true,
        hasDragAndDrop: newValues.length <= PAGE_NUMBER
      });
    case 'removeValues':
      newValues = ((_state$values = state.values) === null || _state$values === void 0 ? void 0 : _state$values.filter(el => el.id !== action.id)) || [];
      return _objectSpread(_objectSpread({}, state), {}, {
        values: newValues,
        hasDragAndDrop: newValues.length <= PAGE_NUMBER
      });
    case 'changeValues':
      return _objectSpread(_objectSpread({}, state), {}, {
        values: action.values,
        hasAllValues: state.id ? action.values.length < PAGE_NUMBER : true,
        hasDragAndDrop: action.values.length <= PAGE_NUMBER
      });
    case 'updateValuesOrder':
      return _objectSpread(_objectSpread({}, state), {}, {
        values: action.values
      });
    case 'setLoading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.value
      });
    case 'setInitLoading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isInitLoading: action.value
      });
    case 'setError':
      return _objectSpread(_objectSpread({}, state), {}, {
        isInitLoading: false,
        error: true
      });
    default:
      throw new Error('No action provided');
  }
}
var _ref6 = /*#__PURE__*/React.createElement(Loader, {
  size: "large"
});
var _ref8 = /*#__PURE__*/React.createElement(NoData, null);
var _ref9 = /*#__PURE__*/React.createElement(Loader, {
  size: "small"
});
const ValueListValues = _ref => {
  var _schema$context, _schema$context$permi, _schema$context2, _schema$context2$perm, _permissions$valueLis, _schema$context3, _schema$context3$perm, _schema$context4, _schema$context4$perm, _permissions$valueLis2, _schema$context5, _schema$context5$perm, _schema$context6, _schema$context6$perm, _permissions$valueLis3;
  let {
    list,
    schema,
    onChange,
    onRemove,
    onStack,
    valueListId,
    valueListName,
    setIds,
    setOriginalIds,
    timeZone,
    overrides,
    getInitialOrder,
    onChangeOrder,
    isForDuplicate
  } = _ref;
  const classes = useStyles();
  const {
    t,
    language,
    permissions,
    overridePermissions,
    columnsToHide,
    isWeb
  } = useWeb5Context({
    overrides
  });
  const offset = useRef(0);
  const formValue = useRef();
  const isFirstLoad = useRef(true);
  const [removeModal, setRemoveModal] = useState({
    isLoading: false,
    isOpen: false,
    id: null,
    index: null,
    values: false,
    body: null
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  const innerOrder = useRef([]);
  const gridApiRef = useRef(null);
  const oldHasDragAndDrop = useRef(false);
  const [withOrder, setWithOrder] = useState(null);
  useEffect(() => {
    if (oldHasDragAndDrop.current === state.hasDragAndDrop || !(gridApiRef !== null && gridApiRef !== void 0 && gridApiRef.current)) return;
    oldHasDragAndDrop.current = state.hasDragAndDrop;
    gridApiRef.current.refreshCells({
      force: true
    });
  }, [state.hasDragAndDrop]);
  const checkOrder = useCallback(data => data.some(value => value.hasOwnProperty('order')), []);
  const get = useCallback(valueListId => {
    return new Promise((resolve, reject) => {
      getValues(valueListId, offset.current).then(_ref2 => {
        let {
          data
        } = _ref2;
        dispatch({
          type: 'addValues',
          values: data.map(value => processFromServer(value, schema))
        });
        const ids = data.map(el => el.id);
        setIds && setIds(ids);
        setOriginalIds && setOriginalIds(ids);
        offset.current += PAGE_NUMBER;
        innerOrder.current = data;
        getInitialOrder({
          values: data
        });
        setWithOrder(checkOrder(data));
        resolve(data);
      }).catch(err => {
        console.error(err);
        dispatch({
          type: 'setError'
        });
      });
    });
  }, [setIds, setOriginalIds, getInitialOrder, checkOrder, schema]);
  const onAdd = useCallback(() => {
    onStack(2);
    formValue.current.open(null, state.values);
  }, [onStack, state.values]);
  const onEdit = useCallback(value => {
    onStack(2);
    formValue.current.open(value, state.values, state.id);
  }, [onStack, state.id, state.values]);

  // Remove modal actions
  const onCloseRemoveModal = useCallback(() => {
    setRemoveModal({
      isLoading: false,
      isOpen: false,
      id: null
    });
  }, [setRemoveModal]);
  const onConfirmRemoveModal = useCallback(() => {
    const finalIds = state.values.map(el => el.id).filter(id => id !== removeModal.id);
    setIds && setIds(finalIds);
    dispatch({
      type: 'removeValues',
      id: removeModal.id,
      index: removeModal.index
    });
    let count = 0;
    const newOrder = state.values.reduce((arr, current) => {
      if (finalIds.includes(current.id)) {
        arr.push(_objectSpread(_objectSpread({}, current), {}, {
          order: count
        }));
        count++;
      }
      return arr;
    }, []);
    innerOrder.current = newOrder;
    onRemove(removeModal.id, removeModal.index);
    onCloseRemoveModal();
  }, [onCloseRemoveModal, onRemove, removeModal, state.values, setIds]);
  const onShowRemoveModal = useCallback(row => {
    if (row.isNew) {
      setRemoveModal({
        isLoading: false,
        isOpen: true,
        id: row.id,
        index: row.index,
        values: false,
        body: t('cfm_label_delete_value_desc')
      });
    } else {
      getValuesUsage(valueListId, row === null || row === void 0 ? void 0 : row.id).then(_ref3 => {
        let {
          data
        } = _ref3;
        const keys = Object.keys(data);
        if ((keys === null || keys === void 0 ? void 0 : keys.length) > 1) setRemoveModal({
          isLoading: false,
          isOpen: true,
          id: row.id,
          index: row.index,
          values: true,
          body: t('label_info_cannot_delete_values_assigned', [row.description])
        });else setRemoveModal({
          isLoading: false,
          isOpen: true,
          id: row.id,
          index: row.index,
          values: false,
          body: t('cfm_label_delete_value_desc')
        });
      }).catch(err => {
        console.error(err);
        showErrorToast(t, err);
      });
    }
  }, [t, valueListId]);
  const onShowMore = useCallback(() => {
    dispatch({
      type: 'setLoading',
      value: true
    });
    get(list.id).then(() => {
      dispatch({
        type: 'setLoading',
        value: false
      });
    }).catch(console.error);
  }, [get, list.id]);
  const onSaveValue = useCallback(data => {
    let values = state.values || [];
    const idx = values.findIndex(v => v.id === data.id);
    if (idx > -1) values = [...values.slice(0, idx), _objectSpread({}, data), ...values.slice(idx + 1)];else values = [_objectSpread({}, data), ...values];
    const finalIds = values.map(el => el.id);
    setIds && setIds(finalIds);
    dispatch({
      type: 'changeValues',
      values
    });
    innerOrder.current = values;
    onChange(values);
  }, [onChange, state.values, setIds]);
  const searchDebounced = debounce(function (text, resolve, reject) {
    if (text === void 0) {
      text = 'a';
    }
    searchValues({
      entity: list.name,
      text,
      lang: language
    }).then(resolve).catch(() => resolve([]));
  }, 250, true);
  const onSelectValue = useCallback(item => {
    if ((item === null || item === void 0 ? void 0 : item.type) === 'change' || !item) return;
    let found = state.values.find(value => value.id === item.value);
    if (!found) getValueDetails(list.id, item.value).then(_ref4 => {
      let {
        data
      } = _ref4;
      const finalData = processFromServer(data, schema);
      onEdit(finalData);
    });
    onEdit(found);
  }, [list.id, onEdit, schema, state.values]);

  // First load
  useEffect(() => {
    if (!isFirstLoad.current) return;
    isFirstLoad.current = false;
    offset.current = 0;
    dispatch({
      type: 'init',
      id: list.id
    });
    if (list.id && !isForDuplicate) get(list.id).catch(console.error);else dispatch({
      type: 'setInitLoading',
      value: false
    });
  }, [get, list.id, state.offset, isForDuplicate]);
  const sortedValues = useMemo(() => {
    if (!state.values) return state.values;
    return state.values.sort((a, b) => {
      const firstDescription = getPriorityTranslation(a, 'description', language.toUpperCase()) || '';
      const secondDescription = getPriorityTranslation(b, 'description', language.toUpperCase()) || '';
      return a.order - b.order || firstDescription.localeCompare(secondDescription);
    });
  }, [language, state.values]);
  const sortValuesByDescription = useCallback(values => {
    if (!values) return values;
    return values.sort((a, b) => {
      return a.description.localeCompare(b.description);
    });
  }, []);
  const rowList = useMemo(() => {
    return sortedValues === null || sortedValues === void 0 ? void 0 : sortedValues.map((item, index) => {
      return _objectSpread(_objectSpread({}, item), {}, {
        order: item.order || '0',
        idToShow: item.id && !item.isNew ? item.id : '-',
        description: getPriorityTranslation(item, 'description', language.toUpperCase()) || '-',
        index: index
      });
    });
  }, [language, sortedValues]);
  const onSearchValues = useCallback(str => {
    return new Promise((resolve, reject) => {
      searchDebounced(str, _ref5 => {
        let {
          data
        } = _ref5;
        let finalData = rowList.filter(value => value.isNew);
        if ((data === null || data === void 0 ? void 0 : data.length) > 0) finalData = [...data, ...finalData];
        resolve(sortValuesByDescription(finalData).map(item => ({
          label: item.description,
          value: item.id
        })));
      }, err => {
        console.error(err);
        reject(err);
      });
    });
  }, [rowList, searchDebounced, sortValuesByDescription]);
  const showValues = state.values && state.values.length > 0;
  const isNewValueList = !list.id;
  const canCreate = (((_schema$context = schema.context) === null || _schema$context === void 0 ? void 0 : (_schema$context$permi = _schema$context.permission) === null || _schema$context$permi === void 0 ? void 0 : _schema$context$permi.create) !== undefined ? (_schema$context2 = schema.context) === null || _schema$context2 === void 0 ? void 0 : (_schema$context2$perm = _schema$context2.permission) === null || _schema$context2$perm === void 0 ? void 0 : _schema$context2$perm.create : true) || overridePermissions || (permissions === null || permissions === void 0 ? void 0 : (_permissions$valueLis = permissions.valueList) === null || _permissions$valueLis === void 0 ? void 0 : _permissions$valueLis.create);
  const canDelete = (((_schema$context3 = schema.context) === null || _schema$context3 === void 0 ? void 0 : (_schema$context3$perm = _schema$context3.permission) === null || _schema$context3$perm === void 0 ? void 0 : _schema$context3$perm.delete) !== undefined ? (_schema$context4 = schema.context) === null || _schema$context4 === void 0 ? void 0 : (_schema$context4$perm = _schema$context4.permission) === null || _schema$context4$perm === void 0 ? void 0 : _schema$context4$perm.delete : true) || overridePermissions || (permissions === null || permissions === void 0 ? void 0 : (_permissions$valueLis2 = permissions.valueList) === null || _permissions$valueLis2 === void 0 ? void 0 : _permissions$valueLis2.delete);
  const canUpdate = (((_schema$context5 = schema.context) === null || _schema$context5 === void 0 ? void 0 : (_schema$context5$perm = _schema$context5.permission) === null || _schema$context5$perm === void 0 ? void 0 : _schema$context5$perm.update) !== undefined ? (_schema$context6 = schema.context) === null || _schema$context6 === void 0 ? void 0 : (_schema$context6$perm = _schema$context6.permission) === null || _schema$context6$perm === void 0 ? void 0 : _schema$context6$perm.update : true) || overridePermissions || (permissions === null || permissions === void 0 ? void 0 : (_permissions$valueLis3 = permissions.valueList) === null || _permissions$valueLis3 === void 0 ? void 0 : _permissions$valueLis3.update);
  const onDragEnd = useCallback(event => {
    const mappedOldOrder = state.values.reduce((obj, current) => {
      obj[current.id] = current;
      return obj;
    }, {});
    const orderIds = innerOrder.current.sort((a, b) => a.order - b.order).map(current => current.id);
    const newOrder = [...orderIds];
    const from = newOrder.indexOf(event.node.data.id);
    const to = event.overIndex;
    const element = newOrder.splice(from, 1)[0];
    newOrder.splice(to, 0, element);
    const finalOrder = newOrder.map((current, index) => _objectSpread(_objectSpread({}, mappedOldOrder[current]), {}, {
      order: index
    }));
    innerOrder.current = finalOrder;
    const rowsToUpdate = finalOrder.map(current => {
      return {
        id: current.id,
        order: current.order
      };
    });
    event.api.applyTransaction({
      update: rowsToUpdate
    });
    dispatch({
      type: 'updateValuesOrder',
      values: finalOrder
    });
    onChangeOrder(finalOrder);
    return Promise.resolve();
  }, [state.values, onChangeOrder]);
  const onRowDrag = useCallback(() => true, []);
  const showGetMore = showValues && !state.hasAllValues && (sortedValues === null || sortedValues === void 0 ? void 0 : sortedValues.length);
  const columns = useMemo(() => {
    let finalColumns = [{
      field: 'order',
      headerName: t('cfm_label_order'),
      cellRenderer: 'textCell',
      cellRendererParams: {
        bold: true
      },
      width: 90,
      resizable: true,
      rowDrag: !isWeb && state.hasDragAndDrop ? onRowDrag : undefined
    }, {
      field: 'description',
      headerName: t('cfm_label_description'),
      resizable: true,
      rowDrag: isWeb && state.hasDragAndDrop ? onRowDrag : undefined
    }, {
      field: 'idToShow',
      headerName: t('cfm_label_id'),
      width: 90,
      resizable: true
    }, {
      field: 'extId',
      headerName: t('cfm_label_extid'),
      width: 90,
      resizable: true
    }];
    if (columnsToHide !== null && columnsToHide !== void 0 && columnsToHide.length) {
      finalColumns = finalColumns.filter(current => !columnsToHide.includes(current.field));
    }
    return finalColumns;
  }, [t, columnsToHide, onRowDrag, state.hasDragAndDrop, isWeb]);
  const actions = useMemo(() => {
    return [row => {
      const isDisabled = row.isView || !canUpdate;
      const allClasses = ['value-list-value__edit'];
      if (isDisabled) allClasses.push(classes.iconDisabled);
      const onClick = isDisabled ? undefined : () => onEdit(row);
      return {
        icon: /*#__PURE__*/React.createElement(Icon, {
          className: allClasses.join(' '),
          onClick: onClick,
          name: "edit"
        })
      };
    }, row => {
      const isDisabled = row.isView || !canDelete;
      const allClasses = ['value-list-value__delete'];
      if (isDisabled) allClasses.push(classes.iconDisabled);
      const onClick = isDisabled ? undefined : () => onShowRemoveModal(row);
      return {
        icon: /*#__PURE__*/React.createElement(Icon, {
          className: allClasses.join(' '),
          onClick: onClick,
          name: "trash"
        })
      };
    }];
  }, [canDelete, canUpdate, classes.iconDisabled, onEdit, onShowRemoveModal]);
  const finalOverrides = useMemo(() => _objectSpread(_objectSpread({}, overrides || {}), {}, {
    fieldsToHide: (overrides === null || overrides === void 0 ? void 0 : overrides.valueListValueFieldsToHide) || []
  }), [overrides]);
  const getRowNodeId = useCallback(data => data.id, []);
  return /*#__PURE__*/React.createElement(Section, {
    title: t('cfm_label_values'),
    className: classes.root
  }, state.isInitLoading && /*#__PURE__*/React.createElement("div", {
    className: classes.initLoader
  }, _ref6), /*#__PURE__*/React.createElement("div", {
    className: classes.values
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }, showValues && /*#__PURE__*/React.createElement(SearchBar, {
    className: classes.toolbarSearch,
    loadOptions: onSearchValues,
    placeholder: t('cfm_placeholder_search'),
    noOptionsPlaceholder: t('label_no_options'),
    loadingPlaceholder: t('wait_loading'),
    onChange: onSelectValue
  }), canCreate && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    type: "terciary",
    onClick: onAdd
  }, t('cfm_action_add_value'))), /*#__PURE__*/React.createElement("div", {
    className: classes.valueListValueTable
  }, /*#__PURE__*/React.createElement(SectionList, {
    id: "valuelistvalue-list",
    onRef: _ref7 => {
      let {
        getApi
      } = _ref7;
      return gridApiRef.current = getApi();
    },
    columns: columns,
    rows: rowList,
    actions: actions,
    headerHeight: 40,
    rowHeight: 40,
    getRowNodeId: getRowNodeId,
    emptyViewProps: {
      icon: _ref8,
      iconType: 'bigIcon',
      title: t('cfm_label_create_value'),
      subtitle: t('cfm_label_create_value_description'),
      button: /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: onAdd
      }, t('cfm_action_add_value'))
    },
    onDragEnd: withOrder && state.hasAllValues && state.hasDragAndDrop ? onDragEnd : null,
    useDragRows: withOrder && state.hasAllValues && state.hasDragAndDrop,
    withoutOffset: true
  })), showGetMore && /*#__PURE__*/React.createElement("div", {
    className: classes.showMoreContainer
  }, state.isLoading && _ref9, !state.isLoading && /*#__PURE__*/React.createElement(Link, {
    onClick: onShowMore
  }, t('cfm_label_more_results')))), /*#__PURE__*/React.createElement(FormValueListValue, {
    onRef: ref => formValue.current = ref,
    isNewValueList: isNewValueList,
    schema: schema,
    onStack: onStack,
    onSave: onSaveValue,
    timeZone: timeZone,
    valueListName: valueListName,
    overrides: finalOverrides
  }), /*#__PURE__*/React.createElement(Modal, {
    title: t('cfm_label_delete_value'),
    size: "small",
    isOpen: removeModal.isOpen,
    onRequestClose: onCloseRemoveModal,
    onCancel: onCloseRemoveModal,
    onConfirm: removeModal.values ? onCloseRemoveModal : onConfirmRemoveModal,
    cancelText: t('cfm_action_cancel'),
    confirmText: t('cfm_action_accept'),
    overrides: {
      confirmButton: {
        type: 'primary-error',
        isLoading: removeModal.isLoading
      }
    }
  }, /*#__PURE__*/React.createElement(Text, null, removeModal.body)));
};
process.env.NODE_ENV !== "production" ? ValueListValues.propTypes = {
  fields: PropTypes.object
} : void 0;
export default /*#__PURE__*/memo(ValueListValues);